import React from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';
import { Suspended } from './components/Suspended';
import { PostPage } from './routes/PostPage';

export const Routes = (): JSX.Element | null => {
  const routeObjects: RouteObject[] = [
    {
      path: '*',
      index: true,
      element: <PostPage />,
    },
  ];

  return useRoutes(routeObjects.map((route) => ({ ...route, element: <Suspended>{route.element}</Suspended> })));
};
